import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import Preloader from '../components/Preloader'

const WhyusSection = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`whychooseus`;  
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [data, setData] = useState([]);
  const [title, setTitle] = useState([]);
  const [loading, setLoading] = useState(true)  
  
  useEffect(() => {
    const fetchPagedata = async () => {
        setLoading(true);
        try {
            const [whyRes, titleRes] = await Promise.all([
            axios.get(apiUrl),
            axios.get(apiBaseUrl + "pagetitle"),
            ]);
            setData(whyRes.data);
            setTitle(titleRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        };
        setLoading(false);
    }
    fetchPagedata();
  }, []);


    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional, for smooth scrolling
        });
    };  

  return (
    <>
    { loading && <Preloader />}
    <section className="work-process-two">
        <div className="container">
            <div className="work-process-two__top">
                <div className="sec-title text-center">
                    { 
                    isHomePage ? 
                    <>
                        <h6 className="sec-title__tagline">{ title?.whyus_heading }</h6>
                        <h3 className="sec-title__title">{ title?.whyus_sub_heading }</h3>
                    </> :
                    <h3 class="sec-title__title">{ title?.whyus_heading }</h3>
                    }
                </div>
            </div>
            <div className="row gutter-y-30">
                {data.map((item, index) => {
                    return (
                    <div className="col-lg-4 col-md-6 wow fadeInUp animated mb-3" data-wow-delay="00ms" style={{ visibility: 'visible', animationDelay: '0ms', animationName: 'fadeInUp' }} key={index}>
                        <div className="work-process-two__item">
                            <div className="work-process-two__item__icon">
                                <img src={ item?.image } alt={`why-us-${index}`}/>
                                <div className="work-process-two__item__number"></div>
                            </div>
                            <h3 className="work-process-two__item__title">{ item?.name }</h3>
                        </div>
                    </div>
                    )
                })}

                { isHomePage && 
                <div className="col-xl-12 col-md-12  pt-5">
                    <div className="portfolio-one__item__btn text-center">
                        <Link className="growim-btn" to="/why-choose-us" onClick={scrollToTop}>
                            <span className="growim-btn__text">View Choose Us</span>
                            <span className="growim-btn__icon"><i className="flaticon-up-right-arrow"></i></span>
                        </Link>		
                    </div>
                </div>
                }
                
            </div>
        </div>
    </section>
    </>
  )
}

export default WhyusSection